module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/notificationmaster/notification-master.component.scss
// module id = ./src/app/component/notificationmaster/notification-master.component.scss
// module chunks = main